import axios from 'axios';

const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5000').replace(/\/$/, '');

export const salarieAPI = {
  // Get all salaries
  getAll: async () => {
    const response = await axios.get(`${API_BASE}/api/salaries`);
    return response.data;
  },

  // Get salary by ID
  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/api/salaries/${id}`);
    return response.data;
  },

  // Create new salary
  create: async (salarieData) => {
    const response = await axios.post(`${API_BASE}/api/salaries`, salarieData);
    return response.data;
  },

  // Update salary
  update: async (id, salarieData) => {
    const response = await axios.put(`${API_BASE}/api/salaries/${id}`, salarieData);
    return response.data;
  },

  // Delete salary
  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/api/salaries/${id}`);
    return response.data;
  }
};